// External deps
import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

// Internal deps
import { userRoles } from '../security/userRoles';
import { constantsSession } from '../constants/constants';
import { getItemStorage } from '../utils/utils';
// This context is about user permission by role
export const UserPermisionsContext = createContext();
UserPermisionsContext.displayName= 'UserPermisionsContext';



const UserPermisionsProvider = ({children}) => {   
    // check is a external user
    const [isUserExternal, setIsUserExternal] = useState(false);
    // check if can be edit me profile 
    const [userPermissions, setUserPermissions] = useState({});

    // check what role I have
    const checkRoles = (rolParams, rolesUser) => {
        const rolFound = rolesUser?.find((rol) => rol.nombre === rolParams);
        return !!rolFound;
      };

      // get all user roles
    const handleAllRolesUser = (rolesArray) => {
        const allUserRoles = {
          isADMINISTRADOR_USUARIO_SEGURIDAD: checkRoles(userRoles.ADMINISTRADOR_USUARIO_SEGURIDAD, rolesArray),
          isADMINISTRADOR_USUARIO_PROPIEDADES: checkRoles(userRoles.ADMINISTRADOR_USUARIO_PROPIEDADES, rolesArray),
          isADMINISTRADOR_CONTRATO: checkRoles(userRoles.ADMINISTRADOR_CONTRATO, rolesArray),
          isADMINISTRADOR_GENERAL_CONTRATOS: checkRoles(userRoles.ADMINISTRADOR_GENERAL_CONTRATOS, rolesArray),
          isREFERENTE_CONTROL_GESTION: checkRoles(userRoles.REFERENTE_CONTROL_GESTION, rolesArray),
          isCONTROL_ERRORES_SAP: checkRoles(userRoles.CONTROL_ERRORES_SAP, rolesArray),
          isUSUARIO_CONSULTAS: checkRoles(userRoles.USUARIO_CONSULTAS, rolesArray),
          isGERENTE_COMPRA: checkRoles(userRoles.GERENTE_COMPRA, rolesArray),
          isINSPECTOR: checkRoles(userRoles.INSPECTOR, rolesArray),
          isLIBERADOR: checkRoles(userRoles.LIBERADOR, rolesArray),
          isCERTIFICADOR: checkRoles(userRoles.CERTIFICADOR),
          isREFERENTE_COMPRAS: checkRoles(userRoles.REFERENTE_COMPRAS, rolesArray),
          isSOLICITANTE: checkRoles(userRoles.SOLICITANTE, rolesArray),
          isSUPERVISOR_NOTIFICADOR_YPF: checkRoles(userRoles.SUPERVISOR_NOTIFICADOR_YPF, rolesArray),
          isRESPONSABLE_PEP_PROYECTO: checkRoles(userRoles.RESPONSABLE_PEP_PROYECTO, rolesArray),
          isAPROBADOR: checkRoles(userRoles.APROBADOR, rolesArray),
          isADMINISTRADOR_USUARIO_EXTERNO: checkRoles(userRoles.ADMINISTRADOR_USUARIO_EXTERNO, rolesArray),
          isAUDITOR_SEGURIDAD: checkRoles(userRoles.AUDITOR_SEGURIDAD, rolesArray),
          isVISUALIZADOR_CONTRATOS: checkRoles(userRoles.VISUALIZADOR_CONTRATOS, rolesArray),
          isPROVEEDOR_ADMINISTRADOR: checkRoles(userRoles.PROVEEDOR_ADMINISTRADOR, rolesArray),
          isPROVEEDOR_NOTIFICADOR: checkRoles(userRoles.PROVEEDOR_NOTIFICADOR, rolesArray)
        };
        setIsUserExternal(
          allUserRoles.isADMINISTRADOR_USUARIO_EXTERNO
          || allUserRoles.isPROVEEDOR_ADMINISTRADOR
          || allUserRoles.isPROVEEDOR_NOTIFICADOR
        );
        return allUserRoles;
      };

      // get user permission about edit profile
    const handlePermissions = () => {
        const rolUserLogger = getItemStorage(constantsSession.ROLES_ME);
        const allUserRoles = handleAllRolesUser(rolUserLogger);
        const userPermissionsObject = {
          userProfile: {
            canEditMeProfile: (
              allUserRoles.isADMINISTRADOR_USUARIO_EXTERNO
            || allUserRoles.isVISUALIZADOR_CONTRATOS
            || allUserRoles.isAPROBADOR
            || allUserRoles.isRESPONSABLE_PEP_PROYECTO
            || allUserRoles.isSUPERVISOR_NOTIFICADOR_YPF
            || allUserRoles.isSOLICITANTE
            || allUserRoles.isREFERENTE_COMPRAS
            || allUserRoles.isCERTIFICADOR
            || allUserRoles.isLIBERADOR
            || allUserRoles.isINSPECTOR
            || allUserRoles.isGERENTE_COMPRA
            || allUserRoles.isUSUARIO_CONSULTAS
            || allUserRoles.isCONTROL_ERRORES_SAP
            || allUserRoles.isREFERENTE_CONTROL_GESTION
            || allUserRoles.isADMINISTRADOR_CONTRATO
            || allUserRoles.isADMINISTRADOR_GENERAL_CONTRATOS)
          }
        };
        setUserPermissions(userPermissionsObject);
      };

    return (
    <UserPermisionsContext.Provider
      value={{
        userPermissions,
        isUserExternal,
        handleAllRolesUser,
        handlePermissions
      }}
    >
      {children}
    </UserPermisionsContext.Provider>
     );
}

UserPermisionsProvider.propTypes = {
    children: PropTypes.element.isRequired
  };
export default UserPermisionsProvider ;